// extracted by mini-css-extract-plugin
var _1 = "list__CGTz6";
var _2 = "list-column__VwzWt";
export { _1 as "list", _2 as "listColumn" }
